import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialFeatured() {
  return <FadeIn delay={0.2} data-id="element-373">
      <section className="py-12 px-4 max-w-4xl mx-auto pt-[0px] pb-[0px]" data-id="element-374">
        <div className="bg-white border border-[#e8dfd0] rounded-2xl p-8 md:p-12 text-center relative overflow-hidden pt-[0px] pb-[0px] shadow-sm" data-id="element-375">
          <Quote className="absolute top-4 left-4 md:top-8 md:left-8 text-[#f5f0e8] w-16 h-16 md:w-24 md:h-24 -z-10 rotate-180" data-id="element-376" />

          <p className="text-xl md:text-3xl font-medium text-[#1a1611] leading-relaxed mb-6 italic relative z-10" data-id="element-377">
            "Armé el contenido de toda la semana en una tarde. Las imágenes con
            IA se ven mejor que las de marcas que conozco."
          </p>

          <div className="flex items-center justify-center gap-3" data-id="element-378">
            <div className="w-10 h-10 bg-[#c9a961] rounded-full flex items-center justify-center text-white font-bold text-lg shadow-md" data-id="element-379">
              M
            </div>
            <div className="text-left" data-id="element-380">
              <p className="font-bold text-[#1a1611]" data-id="element-381">Micaela R.</p>
              <p className="text-sm text-[#6b5d4f] font-medium" data-id="element-382">
                Lashista · Buenos Aires
              </p>
            </div>
          </div>
        </div>
      </section>
    </FadeIn>;
}